export class MessagesModel {
    public CreatedBy: string;
    public CreatedDate: Date;
    public Id: number;
    public IdRequestStatusProcess: number;
    public Message: string;
    public ModifiedBy: string;
    public ModifiedDate: Date;
}